// extracted by mini-css-extract-plugin
export var typingIndicator = "_p6-0";